import { __decorate } from "tslib";
import CombinedPicture from '@blade-sxp/portrait-management/components/combined-picture.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Scale } from '@blade/common/utils/auto-scale';
import colors from '@/styles/color.scss';
let default_1 = class default_1 extends Vue {
    src; // 图片的地址
    check; // 当前暂存的值
    activeValue; // 勾选的值
    unactiveValue; // 取消勾选的值
    allowSelect; // 允许选中 用于模式之间的切换
    disabled; // 失效状态
    /** 图标大小 */
    iconSize = 20;
    portraitStatusInvalidating = 'INVALIDATING'; // 失效
    /** 图像最大宽度 */
    get imageMaxWidth() {
        return 146 * Scale;
    }
    /** 图像最大高度 */
    get imageMaxHeight() {
        return 146 * Scale;
    }
    getDisable(val) {
        return val === this.portraitStatusInvalidating ? `background:${colors.libary}` : `background:${colors.buttonGrey}`;
    }
    /** 勾选卡片 */
    handleCheckCard() {
        this.$emit('update:check', this.unactiveValue);
    }
    /** 取消勾选卡片 */
    handleUnCheckCard() {
        this.$emit('update:check', this.activeValue);
    }
    /** 点击卡片 */
    handleClick() {
        this.$emit('click', this.activeValue);
    }
    /** 点击蒙版 */
    handleMaskClick() {
        this.$emit('click', this.activeValue);
    }
};
__decorate([
    Prop()
], default_1.prototype, "src", void 0);
__decorate([
    Prop()
], default_1.prototype, "check", void 0);
__decorate([
    Prop()
], default_1.prototype, "activeValue", void 0);
__decorate([
    Prop({ default: null })
], default_1.prototype, "unactiveValue", void 0);
__decorate([
    Prop()
], default_1.prototype, "allowSelect", void 0);
__decorate([
    Prop()
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        components: {
            CombinedPicture,
        },
    })
], default_1);
export default default_1;
